module.exports = __webpack_public_path__ + "faq/img/login2.0496ceb0.png";